module.exports = __webpack_public_path__ + "static/media/SM-MT-8.635335fb.mp3";